import { Box, Card, CardContent, Stack, Typography } from '@mui/material'
import SearchOffRoundedIcon from '@mui/icons-material/SearchOffRounded'
import { useTranslation } from 'react-i18next'

interface Props {
  compact?: boolean
  embedded?: boolean
  title?: string
  description?: string
}

export default function AccountNoResults(props: Props) {
  const [t] = useTranslation('account-v2')

  return <Card
    role="status"
    variant={props.embedded ? undefined : 'dashed'}
    elevation={0}
    sx={{
      width: '100%',
      minHeight: props.compact ? 140 : {
        xs: 180,
        md: 220,
      },
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      ...(props.embedded && {
        backgroundColor: 'transparent',
        border: 0,
      }),
    }}
  >
    <CardContent
      sx={{
        width: '100%',
        p: {
          xs: 3,
          md: props.compact ? 3 : 4,
        },
        '&:last-child': {
          pb: {
            xs: 3,
            md: props.compact ? 3 : 4,
          },
        },
      }}
    >
      <Stack spacing={1.5} alignItems="center" textAlign="center">
        <Box
          component="div"
          sx={{
            color: 'text.secondary',
            lineHeight: 0,
          }}
        >
          <SearchOffRoundedIcon fontSize="small" />
        </Box>
        <Typography variant="h3">{props.title ?? t('No results found')}</Typography>
        <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 360 }}>
          {props.description ?? t('Try adjusting your search or filters.')}
        </Typography>
      </Stack>
    </CardContent>
  </Card>
}
